import {
  AddDeliveryLocation,
  DeliveryTimeType,
} from '../../redux-toolkits/products/products.type'

type DeliveryLocationSource = {
  locationId?: string | { _id?: string; name?: string; slug?: string } | null
  minimumDeliveryTime?: number
  maximumDeliveryTime?: number
  type?: string
  deliveryTime?: string
  locationType?: 'delivery' | 'pickup' | 'region'
}

type ProductDeliveryLocationSource = DeliveryLocationSource & {
  locationType?: 'delivery' | 'pickup' | 'region'
}

type CreatorLocationSource = {
  deliveryLocation?: DeliveryLocationSource[]
  deliveryLocations?: DeliveryLocationSource[]
}

function isProductDeliveryLocation(
  location: DeliveryLocationSource,
): location is ProductDeliveryLocationSource {
  return !!location
}

export const mapDeliveryLocationsToForm = (
  locations?: DeliveryLocationSource[],
): AddDeliveryLocation[] => {
  return (locations ?? [])
    .filter(isProductDeliveryLocation)
    .map((loc) => {
      const locationId =
        typeof loc.locationId === 'string'
          ? loc.locationId
          : loc.locationId?._id

      return {
        locationId: locationId ?? '',
        locationName:
          typeof loc.locationId === 'string'
            ? undefined
            : loc.locationId?.name ?? loc.locationId?.slug,
        minimumDeliveryTime: loc.minimumDeliveryTime,
        maximumDeliveryTime: loc.maximumDeliveryTime,
        type: loc.type as DeliveryTimeType | undefined,
        deliveryTime: loc.deliveryTime ?? '',
        locationType: loc.locationType ?? 'region',
      }
    })
    .filter((loc) => loc.locationId)
}

export const mapCreatorLocationsToForm = (
  creator?: CreatorLocationSource,
): AddDeliveryLocation[] => {
  const locations =
    creator?.deliveryLocation && creator.deliveryLocation.length > 0
      ? creator.deliveryLocation
      : creator?.deliveryLocations

  return mapDeliveryLocationsToForm(locations)
}
